import React from "react";
import classes from "./GradientButton.module.scss";

const GradientButton: React.FC<{
  text: string;
  onClick: () => void;
  className?: any;
}> = ({ text, onClick, className }) => {
  return (
    <button
      className={`${classes.button} ${className || ""}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default GradientButton;
